import { Flex, Icon, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';

type StatCardProps = {
	label: string;
	value: string | number;
	icon: IconType;
	/** Highlights the side rule in brass instead of steel. */
	accent?: boolean;
};

/**
 * Dashboard metric card: an icon chip, an uppercase label and a big display
 * number, with a colored side rule. Replaces the four hand-built cards so they
 * line up and read as one set.
 */
export const StatCard = ({ label, value, icon, accent }: StatCardProps) => {
	return (
		<Flex
			position="relative"
			overflow="hidden"
			bg="white"
			border="1px solid"
			borderColor="mist"
			borderRadius="14px"
			boxShadow="sm"
			px="18px"
			py="16px"
			align="center"
			gap="14px"
			minW={{ base: '100%', md: '210px' }}
			flex={{ md: 1 }}
			_before={{
				content: '""',
				position: 'absolute',
				left: 0,
				top: '14px',
				bottom: '14px',
				width: '3px',
				borderRadius: '3px',
				bg: accent ? 'brass.500' : 'steel'
			}}
		>
			<Flex
				align="center"
				justify="center"
				boxSize="44px"
				borderRadius="12px"
				bg="blue.50"
				color="blue.700"
				flexShrink={0}
			>
				<Icon as={icon} boxSize="22px" />
			</Flex>
			<Flex direction="column">
				<Text
					fontSize="11px"
					fontWeight="700"
					letterSpacing="0.08em"
					textTransform="uppercase"
					color="gray.500"
				>
					{label}
				</Text>
				<Text fontFamily="heading" fontSize="30px" fontWeight="800" lineHeight="1.1" color="ink">
					{value}
				</Text>
			</Flex>
		</Flex>
	);
};
